import module from 'app/module.js'
import template from './template.html'

class AppExcelImportarComponent {
  constructor () {
    this.headers = null
    this.model = null
    this.onChange = null
    this.data = null
  }

  $onChanges (changes) {
    if (changes.headers) {
      this.headers = [...this.headers]
        .map((config) => Object.assign({
          id: undefined,
          name: undefined,
          group: undefined,
          parser: (e) => e,
          processor: (e) => e,
          match: () => false,
        }, config))
    }
  }

  actualizar (data) {
    this.data = data

    this.procesar()
  }

  decodificar (data) {
    this.data = {
      headers: data.headers.map((value) => value ? this.headers.find((item) => item.match(value) === true) : undefined),
      rows: data.rows,
    }

    this.procesar()
  }

  procesar () {
    let data, headers

    if (this.data) {
      headers = this.data.headers.map((item) => item && item.id)

      data = this.data.rows.map((celdas) => {
        let model = this.model ? new this.model() : {}

        return this.data.headers.reduce((object, header, index) => {
          if (!header) return object

          let cell = celdas[index]
          let value = header.parser(cell === undefined ? '' : cell)

          return header.processor(object, value)
        }, model)
      })
    }

    this.onChange({$event: {data: data, headers: headers}})
  }
}

module.component('appExcelImportar', {
  controller: AppExcelImportarComponent,
  template,
  bindings: {
    headers: '<',
    model: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/app/components/excel/importar/component.js